import { Text, TextProps } from '@chakra-ui/react';
import { FormattedMessage } from 'react-intl';

type NoEntriesProps = {
    message?: string;
    textProps?: TextProps;
};

export const NoEntries = (props: NoEntriesProps) => {
    const { message, textProps } = props;

    return (
        <Text textAlign="center" fontWeight="semibold" color="grey.700" {...textProps}>
            <FormattedMessage id={message || 'no-results'} />
        </Text>
    );
};
